module.exports = __webpack_public_path__ + "img/clients-slider-bg.1334c27b.png";